/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Managed collection type enumeration.
 */
export type CollectionKind = typeof CollectionKind[keyof typeof CollectionKind];


export const CollectionKind = {
  category: 'category',
  banner: 'banner',
  subcategory: 'subcategory',
  editorial: 'editorial',
  ranking: 'ranking',
  author: 'author',
  lector: 'lector',
  publisher: 'publisher',
  series: 'series',
  tag: 'tag',
  emotion: 'emotion',
  personal: 'personal',
} as const;
